module.exports = __webpack_public_path__ + "media/customizations/tributary/back-ca4d3fe0e308b6639f096e092833b6ac.jpg";